export default {
  users: {
    icon: 'account_circle',
    title: ['Usuário', 'Usuários'],
    field: {
      id: 'Código',
      id_text: 'Nome',
      email: 'E-mail',
      password: 'Senha',
      confirmation: 'Confirmação',
      company_id: 'Empresa',
      username: 'Nome de Usuário',
      cpf: 'CPF',
      photo_path: 'Foto',
      gender: 'Gênero',
      birth: 'Data de Nascimento',
      city: 'Cidade',
      state: 'Estado',
      country: 'País',
      language: 'Idiomas',
      bio: 'Sobre Você',
      occupation: 'Ocupação',
      phone: 'Telefone',
      links: 'Links'
    }
  },
  calendar: {
    icon: 'calendar_today',
    title: ['Agenda', 'Agendas']
  },
  dashboard: {
    icon: 'dashboard',
    title: ['Dashboard', 'Dashboards']
  },
  companyParticipants: {
    icon: 'portrait',
    title: ['Usuários da Empresa', 'Usuários da Empresa']
  },
  custom_fields: {
    icon: 'list',
    title: ['Campo Personalizado', 'Campos Personalizados'],
    field: {
      company_id: 'Empresa',
      task_id: 'Tarefa',
      tasktemplate_id: 'Tarefa Modelo',
      title: 'Título',
      id_text: 'Valor',
      type: 'Tipo',
      active: 'Ativo'
    }
  },
  custom_field_options: {
    icon: 'list',
    title: ['Opção', 'Opções'],
    field: {
      custom_field_id: 'Campo Personalizado',
      id_text: 'Descrição'
    }
  },
  dashboards: {
    icon: 'list',
    title: ['Dashboard', 'Dashboards'],
    field: {
      task_board_id: 'Área de Trabalho',
      id_text: 'Configurações'
    }
  },
  dashboard_chart: {
    icon: 'list',
    title: ['Gráfico', 'Gráficos'],
    field: {
      id_text: 'Título',
      color: 'Cor',
      card_type: 'Tipo',
      fields: 'Campos',
      grouping_fields: 'Agrupamento'
    }
  },
  tasks: {
    icon: 'list',
    title: ['Tarefa', 'Tarefas'],
    field: {
      identifier: 'ID',
      identifier_sequence: 'ID',
      all_subtasks: 'Subtarefas',
      company_id: 'Empresa',
      id_text: 'Descrição',
      user_id: 'Responsável',
      team_id: 'Equipe',
      commitment: 'Compromisso',
      client_id: 'Cliente',
      connection_id: 'Conexão',
      connection_company_id: 'Empresa da Conexão',
      category_id: 'Categoria',
      level: 'Nível',
      begin: 'Início',
      end: 'Previsão',
      task_status_id: 'Status',
      urgency: 'Urgência',
      column_duration: 'Duração',
      column_all_duration: 'Duração Total',
      note: 'Observação',
      shared: 'Compartilhada',
      password: 'Senha',
      recurrence_id: 'Recorrência'
    }
  },
  // Usado para colocar os valores no pfilter do calendar
  calendar_task: {
    icon: 'list',
    title: ['Tarefa', 'Tarefas'],
    field: {
      identifier: 'ID',
      company_id: 'Empresa',
      id_text: 'Descrição',
      user_id: 'Responsável',
      team_id: 'Equipe',
      client_id: 'Cliente',
      connection_id: 'Conexão',
      connection_company_id: 'Empresa da Conexão',
      category_id: 'Categoria',
      begin: 'Início',
      end: 'Previsão',
      task_status_id: 'Status',
      urgency: 'Urgência',
      note: 'Observação'
    }
  },
  task_recurrence: {
    field: {
      type: 'Tipo',
      id_text: 'Descrição'
    }
  },
  tasktemplates: {
    icon: 'file_copy',
    title: ['Modelo de Tarefa (POP)', 'Modelos de Tarefa (POPs)'],
    field: {
      all_subtasks: 'SubTarefas',
      identifier: 'ID',
      id_text: 'Descrição',
      user_id: 'Responsável',
      team_id: 'Equipe',
      client_id: 'Cliente',
      connection_id: 'Conexão',
      connection_company_id: 'Empresa da Conexão',
      category_id: 'Categoria',
      prevision: 'Previsão',
      urgency: 'Urgência',
      note: 'Observação'
    }
  },
  reports: {
    icon: 'library_books',
    title: ['Relatório', 'Relatórios'],
    field: {
      id_text: 'Nome',
      connections_id: 'Clientes',
      user_id: 'Responsáveis',
      durations: 'Durações'
    }
  },
  forms: {
    icon: 'library_books',
    title: ['Formulário', 'Formulários'],
    field: {
      company_id: 'Empresa',
      tasktemplate_id: 'Tarefa Modelo',
      id_text: 'Título',
      description: 'Descrição do Formulário',
      custom_fields: 'Campos personalizados',
      task_description: 'Descrição da Tarefa',
      begin_status_id: 'Status Inicial',
      prevision: 'Previsão',
      active: 'Ativo'
    }
  },
  companies: {
    icon: 'business',
    title: ['Empresa', 'Empresas'],
    field: {
      id_text: 'Nome',
      active: 'Ativo',
      company_id: 'Empresa',
      fantasy_name: 'Nome Fantasia',
      illis_name: 'Nome Illis',
      type_person: 'Tipo de Pessoa',
      cpfcnpj: 'C.P.F./C.N.P.J.',
      rgie: 'R.G./I.E.',
      logo_path: 'Logo',
      city: 'Cidade',
      state: 'Estado',
      country: 'País',
      address: 'Endereço',
      number: 'Número',
      neighborhood: 'Bairro',
      complement: 'Complemento',
      cep: 'C.E.P.',
      bio: 'Sobre Nós',
      market: 'Mercado de Atuação',
      phone: 'Telefone',
      email: 'E-mail',
      links: 'Links',
      plan: 'Plano',
      segments: 'Segmentos'
    }
  },
  payments: {
    icon: 'business',
    title: ['Assinatura', 'Assinaturas'],
    field: {
      user_id: 'Usuário',
      company_id: 'Empresa',
      plan_id: 'Plano',
      payment_method: 'Forma de pagamento',
      paid: 'Pago',
      value: 'Valor',
      date: 'Data do Pagamento',
      status: 'Status',
      created_at: 'Data de emissão',
      access_days: 'Dias de Acesso'
    }
  },
  payment_bills: {
    icon: 'business',
    title: ['Fatura', 'Faturas'],
    field: {
      payment_type: 'Tipo',
      payment_status: 'Pagamento',
      paid: 'Pago',
      due_date: 'Vencimento da fatura',
      expired: 'Expiração do plano',
      created_at: 'Data de emissão'
    }
  },
  payment_cancel: {
    icon: 'business',
    title: ['Cancelamento', 'Cancelamentos'],
    field: {
      user_id: 'Usuário',
      company_id: 'Empresa',
      cancel_id: 'Motivo do Cancelamento',
      id_text: 'Deixe o seu feedback'
    }
  },
  files: {
    icon: 'description',
    title: ['Arquivo', 'Arquivos'],
    field: {
      company_id: 'Empresa',
      id_text: 'Nome',
      source: 'Origem',
      path: 'Caminho',
      extension: 'Extensão',
      size: 'Tamanho',
      note: 'Observação',
      category_id: 'Categoria',
      subcategory_id: 'Subcategoria',
      emission: 'Emissão | Competência',
      maturity: 'Vencimento',
      task_id: 'Tarefa',
      user_id: 'Usuário',
      password: 'Senha',
      email: 'e-mail',
      shared: 'Tarefa Compartilhada',
      created_at: 'Data de postagem'
    }
  },
  accesses: {
    icon: 'lock',
    title: ['Acesso', 'Acessos'],
    field: {
      id_text: 'Nome',
      description: 'Descrição',
      permissions: 'Permissões'
    }
  },
  connections: {
    icon: 'group_work',
    title: ['Cliente (Parceiro)', 'Clientes (Parceiros)'],
    field: {
      identifier: 'Código',
      type_person: 'Tipo de Pessoa',
      company_id: 'Empresa',
      connection_company_id: 'Empresa',
      connection_id: 'Conexão',
      id_text: 'Nome',
      cpfcnpj: 'C.P.F./C.N.P.J.',
      rgie: 'R.G./I.E.',
      country: 'País',
      main_contact: 'Contato(s)',
      state: 'Estado',
      city: 'Cidade',
      address: 'Endereço',
      status: 'Status',
      type: 'Tipo',
      number: 'Número',
      neighborhood: 'Bairro',
      complement: 'Complemento',
      cep: 'C.E.P.',
      phone: 'Telefone',
      email: 'E-mail',
      active: 'Ativo',
      note: 'Observação'
    }
  },
  company_user: {
    icon: 'person',
    title: ['Participante', 'Participantes'],
    field: {
      user_id: 'Participante',
      status: 'Status',
      admin: 'Administrador',
      access_id: 'Acesso'
    }
  },
  task_board: {
    icon: '',
    title: ['Área de trabalho', 'Área de trabalho'],
    field: {
      user_id: 'Usuário',
      company_id: 'Empresa',
      id_text: 'Item',
      properties: 'Propriedades'
    }
  },
  task_checklist: {
    icon: '',
    title: ['Listagem', 'Listagens'],
    field: {
      id_text: 'Item',
      description: 'Descrição',
      user_id: 'Usuário',
      company_id: 'Empresa',
      done: 'Concluído'
    }
  },
  task_status: {
    icon: '',
    title: ['Status', 'Status'],
    field: {
      identifier: 'Código',
      company_id: 'Empresa',
      id_text: 'Descrição',
      color: 'Cor',
      active: 'Ativo'
    }
  },
  task_category: {
    icon: '',
    title: ['Categoria', 'Categorias'],
    field: {
      identifier: 'Código',
      company_id: 'Empresa',
      id_text: 'Descrição',
      color: 'Cor',
      active: 'Ativo'
    }
  },
  task_dependency: {
    icon: '',
    title: ['Pré-requisito', 'Pré-requisitos'],
    field: {
      task_dependent_id: 'Dependente',
      task_dependency_id: 'Dependência'
    }
  },
  tasktemplate_checklist: {
    icon: '',
    title: ['Listagem', 'Listagens'],
    field: {
      id_text: 'Título',
      description: 'Descrição',
      done: 'Concluído'
    }
  },
  tasktemplate_document: {
    icon: '',
    title: ['Documento', 'Documentos'],
    field: {
      id_text: 'Título',
      description: 'Descrição'
    }
  },
  tasktemplate_automation: {
    icon: '',
    title: ['Automação', 'Automações'],
    field: {
      tasktemplate_id: 'Tarefa Modelo',
      form_id: 'Formulário',
      type: 'Tipo',
      fields: 'Campos',
      values: 'Valores',
      action: 'Faça',
      config: 'Configuração',

      id_text: 'Descrição',
      origin: 'Origem'
    }
  },
  task_reminder: {
    icon: '',
    title: ['Lembrete', 'Lembretes'],
    field: {
      type: 'Tipo',
      user_id: 'Usuário',
      company_id: 'Empresa',
      date: 'Data'
    }
  },
  tasktemplate_reminder: {
    icon: '',
    title: ['Lembrete', 'Lembretes'],
    field: {
      type: 'Tipo',
      user_id: 'Usuário',
      quantity: 'Quantidade',
      indicator: 'Indicador'
    }
  },
  task_duration: {
    icon: 'watch',
    title: ['Duração', 'Durações'],
    field: {
      begin: 'Data Inicial',
      end: 'Data Final',
      user_id: 'Usuário',
      company_id: 'Empresa',
      duration: 'Duração',
      note: 'Observação'
    }
  },
  task_calendar: {
    icon: 'calendar',
    title: ['Agenda', 'Agenda'],
    field: {
      begin: 'Data Inicial',
      end: 'Data Final',
      user_id: 'Usuário',
      company_id: 'Empresa',
      duration: 'Duração',
      all_day: 'Dia Inteiro'
    }
  },
  task_user: {
    icon: '',
    title: ['Participante', 'Participantes'],
    field: {
      task_id: 'Tarefa',
      user_id: 'Nome',
      connection_id: 'Conexão',
      connection_company_id: 'Empresa da Conexão',
      note: 'Observação',
      id_text: 'Nome',
      email: 'E-mail'
    }
  },
  task_user_external: {
    icon: '',
    title: ['Outro Participante', 'Outros Participantes'],
    field: {
      task_id: 'Tarefa',
      note: 'Observação',
      id_text: 'Nome',
      email: 'E-mail'
    }
  },
  tasktemplate_user: {
    icon: '',
    title: [
      'Participante',
      'Participantes'],
    field: {
      user_id: 'Nome',
      connection_id: 'Conexão',
      connection_company_id: 'Empresa da Conexão',
      note: 'Observação'
    }
  },
  task_comment: {
    icon: '',
    title: ['Comentário', 'Comentários'],
    field: {
      user_id: 'Autor',
      company_id: 'Empresa',
      id_text: 'Novo'
    }
  },
  permissions: {
    icon: 'lock',
    title: ['Permissão', 'Permissões'],
    field: {
      id_text: 'Nome',
      view: 'Visualizar',
      create: 'Criar',
      edit: 'Editar',
      delete: 'Deletar',
      manage: 'Gerenciar'
    }
  },
  messages: {
    icon: 'forum',
    title: ['Recado', 'Recados'],
    field: {
      id: 'Código',
      sender_id: 'Remetente',
      recipient_id: 'Destinatário',
      status: 'Status',
      id_text: 'Mensagem',
      urgency: 'Urgência'
    }
  },
  teams: {
    icon: 'group',
    title: ['Equipe', 'Equipes'],
    field: {
      id_text: 'Nome',
      active: 'Ativo'
    }
  },
  team_user: {
    icon: '',
    title: ['Participante', 'Participantes'],
    field: {
      user_id: 'Participante',
      connection_id: 'Conexão',
      type: 'Tipo',
      manager: 'Responsável'
    }
  },
  activity_log: {
    icon: 'list_alt',
    title: ['Histórico', 'Histórico'],
    field: {
      attributes: 'Descrição'
    }
  },
  notifications: {
    icon: '',
    title: ['Notificações', 'Notificações'],
    field: {
      title: 'Título',
      id_text: 'Descrição',
      done: 'Visto'
    }
  },
  select_editable: {
    icon: '',
    title: ['Registro', 'Registros'],
    field: {
      company_id: 'Empresa',
      id_text: 'Descrição',
      type: 'Tipo',
      active: 'Ativo'
    }
  },
  changelog: {
    icon: 'history',
    title: ['Registro de alteração', 'Registro de alterações']
  }
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/table.js